import { useEffect } from 'react'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { getFunctions, httpsCallable } from 'firebase/functions'

const AffiliateTracker: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()
  
  useEffect(() => {
    const trackAffiliate = async () => {
      const affiliateId = searchParams.get('aff')
      
      if (affiliateId) {
        try {
          const functions = getFunctions()
          const checkAffiliate = httpsCallable(functions, 'checkAffiliate')
          await checkAffiliate({ affiliateId })
          console.log('Affiliate visit tracked from site root:', affiliateId)
          
          // Store affiliate ID in localStorage for signup tracking
          // The signup functions will read this and set custom claims
          localStorage.setItem('affiliateId', affiliateId)
          navigate('/auth/registration', { replace: true })
          
        } catch (error) {
          console.error('Error tracking affiliate visit from site root:', error)
        }
      }
    }

    trackAffiliate()
  }, [searchParams, navigate, location])

  return null // This component doesn't render anything
}

export default AffiliateTracker
